import { GET_CATEGORIES } from '../types';

export const getCategoriesData = (data) => (dispatch) => {
  dispatch({
    type: GET_CATEGORIES,
    payload: data,
  });
};
